import { gql, useQuery } from '@apollo/client';
import {
  AvailableSpacesQuery,
  AvailableSpacesQueryVariables,
} from '@pv/common/graphql/operations';

export const fetchAvailableSpaces = gql`
  query AvailableSpaces(
    $organizationSlug: String
    $venueSlug: String
    $seated: [Int!]
    $standing: [Int!]
    $startDate: ISO8601Date
    $startOffset: Int
    $endOffset: Int
  ) {
    availableSpaces(
      organizationSlug: $organizationSlug
      venueSlug: $venueSlug
      seated: $seated
      standing: $standing
      startDate: $startDate
      startOffset: $startOffset
      endOffset: $endOffset
    ) {
      slug
      name
      description
      seated
      standing
      images(limit: 1) {
        id
        url
      }
      venue {
        id
        slug
        name
        liveAvailability
        priceCategory
        images(limit: 1) {
          id
          url
        }
        profileBanner
        address {
          id
          city
          state
          latitude
          longitude
        }
      }
      pathname
      expressBookEnabled
    }
  }
`;

export const useAvailableSpaces = (
  variables: AvailableSpacesQueryVariables,
  skip: boolean,
) => {
  return useQuery<AvailableSpacesQuery, AvailableSpacesQueryVariables>(
    fetchAvailableSpaces,
    { variables, skip },
  );
};

export const fetchOrganization = gql`
  query MarketplaceOrganization($slug: String!) {
    marketplaceOrganization(slug: $slug) {
      id
      slug
      name
      logoUrl
      venues {
        id
        name
        slug
        address {
          id
          latitude
          longitude
        }
        expressBookSettings {
          id
          minLeadTimeDays
          maxLeadTimeDays
          minEventDurationHours
          maxEventDurationHours
        }
        hoursOfOperation {
          id
          isOpen
          startTime
          endTime
          dayOfWeek
        }
      }
      latitude
      longitude
    }
  }
`;

export const fetchVenue = gql`
  query MarketplaceVenue($slug: String!) {
    marketplaceVenue(slug: $slug) {
      id
      slug
      name
      description
      priceCategory
      address {
        id
        longitude
        latitude
        streetAddress1
        city
        state
        zip
        country
        formattedAddress
      }
      logo
      profileBanner
      helloLeadFormUrl
      websiteUrl
      menu {
        id
        menuItems(displayOnExpressBook: true) {
          id
        }
        previewMenuItems(limit: 4) {
          id
          name
          image(width: 500, height: 300)
        }
      }
      hoursOfOperation {
        id
        dayOfWeek
        isOpen
        startTime
        endTime
      }
      expressBookSettings {
        id
        minLeadTimeDays
        maxLeadTimeDays
        minEventDurationHours
        maxEventDurationHours
      }
      type
    }
  }
`;
